import noScroll from 'no-scroll';

import env from '../env/env.js';

// Prevent the document from scrolling.  Useful if e.g. modal is
// showing and you don't want the background to be scrollable.
export const setNoScroll = (isModalOpen, disableModalAttributes) => {
  if (env.isClient) {
    if (isModalOpen) {
      noScroll.on();
      if (!disableModalAttributes) {
        document.documentElement.setAttribute('data-modal', 'true');
      }
    } else {
      noScroll.off();
      if (!disableModalAttributes) {
        document.documentElement.setAttribute('data-modal', 'false');
      }
    }
  }
};
